export default "__VITE_ASSET__oF$HQsq8__"